//READ MORE BTNS FOR TRUNCATED CONTENT
$(".read-more-btn").each(function () {
  let readMoreText = $(this).attr("data-read-more-text");
  let readLessText = $(this).attr("data-read-less-text");
  let shownTextLength = $(this).siblings(".truncated-text").text().length;
  $(this).click(function () {
    let textExpanded = $(this).siblings(".read-more-input").prop("checked");
    if (!textExpanded) {
      $(this).text(readLessText);
    } else {
      $(this).text(readMoreText);
    }
  });

  if (
    window.matchMedia("(max-width: 481px)").matches &&
    shownTextLength > 150
  ) {
    $(this).css("display", "inline-block");
  } else if (
    window.matchMedia("(min-width: 482px)").matches &&
    shownTextLength > 250
  ) {
    $(this).css("display", "inline-block");
  }
});

// POPUP MODAL
// Get the current popup
let popup;
// Get all popups
var $popups = $(".popup");
// Get the button that opens the modal
var $popupOpenBtns = $(".popup__open");
// Get the <span> element that closes the modal
let $popupClose = $(".popup__close");

// wait for window to load and then for each popup call waitAndOpenPopup function
$(window).on("load", function () {
  $popups.each(function () {
    const { customer, delay, expires } = $(this).data("settings");
    waitAndOpenPopup($(this), $(this).data("settings"), delay, expires);
    popup = $(this);
  });
});

// for each popup close button find the closest modal and close it
$popupClose.each(function () {
  $(this).click(function () {
    closePopup($(this).closest(".popup"));
  });
});

// for each popup open button find the closest modal and open it
$popupOpenBtns.each(function () {
  $(this).click(function () {
    popup = $(this).next(".popup");
    openPopup(popup);
  });
});

// When the user clicks anywhere outside of the popup, close it
if (popup != undefined) {
  $(window).click(function (event) {
    if (event.target.id == popup.attr("id")) {
      closePopup(popup);
    }
  });
}

// function to open popup
function openPopup(popup) {
  popup.css("display", "block");
}

// function to close popup
function closePopup(popup) {
  popup.css("display", "none");
}

// function to wait for a certain time and then open popup
function waitAndOpenPopup(popup, value, delay, expires) {
  const cookie = "popup-" + popup.attr("id");
  const settingsString = JSON.stringify(value);

  // check if cookie is set
  if (getCookie(cookie) == settingsString) {
    // if expires is set to -1 then reset the cookie and extend the expires to an additional 1 year
    if (expires == -1) {
      setCookie(cookie, settingsString, 365);
    }
    return;
  }
  // set cookie name as popup ID and value as true for expires
  setCookie(cookie, settingsString, expires);
  // wait for delay and then open popup
  setTimeout(function () {
    openPopup(popup);
  }, delay);
}

// function to set cookie for popup
function setCookie(cname, cvalue, exdays) {
  // if exdays is set to -1 then set the cookie to expire in 1 year
  if (exdays == -1) {
    exdays = 365;
  }
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

// function to get cookie for popup
function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

const handleReorder = (el) => {
  toggleSpinner(el);
  let formData = {
    items: JSON.parse(el.getAttribute("data-order-data")),
  };

  fetch(window.Shopify.routes.root + "cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => {
      if (response.ok) {
        window.location.href = "/cart";
      } else {
        window.location.href = "/products/o-plano-alimentar-do-seu-cao";
      }
    })
    .finally(() => {
      toggleSpinner(el);
    });
};

const mbEditOrder = async (el) => {
  const formData = {
    items: JSON.parse(el.getAttribute("data-order-data")),
  };

  try {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    // only set sesstion storage if device is not mobile
    if (window.matchMedia("(min-width: 767px)").matches) {
      sessionStorage.setItem("multibanco-edit", true);
    }
    window.location.href =
      "/collections/adicione-mais-produtos-a-sua-encomenda";
  } catch (error) {
    console.log(error);
  }
};

const mbAddProductToOrder = async (el) => {
  let formData = {
    items: JSON.parse(el.getAttribute("data-order-data")),
  };

  const qtyEl = document.querySelector(
    `[data-product="${formData.items[0].id}"]`
  );

  if (qtyEl) {
    formData.items[0].quantity = parseInt(qtyEl.value);
  }

  try {
    await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    // only set sesstion storage if device is not mobile
    if (window.matchMedia("(min-width: 767px)").matches) {
      sessionStorage.setItem("multibanco-edit", true);
    }
    // window.location.href =
    //   '/collections/adicione-mais-produtos-a-sua-encomenda';
  } catch (error) {
    console.log(error);
  }
};

// function to show spinner
function toggleSpinner(el) {
  $(el).toggleClass("button--loading");
}

// function to set toaster in session storage
function setToaster(title, message, type) {
  sessionStorage.setItem("toaster", JSON.stringify({ title, message, type }));
}

// function to show toaster
function configureToaster(title, message, type) {
  var toaster = $("#toaster");
  toaster.find(".toaster__title").html(title);
  toaster.find(".toaster__text").html(message);
  toaster.toggleClass("toaster--active");
  toaster.attr("data-toaster-state", type);
  setTimeout(function () {
    toaster.toggleClass("toaster--active");
  }, 5000);
}

// function to check session storage for toaster
function showToaster() {
  if (sessionStorage.getItem("toaster")) {
    const { title, message, type } = JSON.parse(
      sessionStorage.getItem("toaster")
    );
    configureToaster(title, message, type);
    sessionStorage.removeItem("toaster");
  }
}

function toggleSidecart() {
  sessionStorage.getItem("multibanco-edit") &&
    (sessionStorage.removeItem("multibanco-edit"),
    $("side-cart").toggleClass("side-cart--active"));
}

function calculateImageHeight() {
  const contentWrapper = document.querySelector(
    ".ritual-email-step .content-wrapper"
  );
  const imageWrapper = document.querySelector(
    ".ritual-email-step .image-wrapper"
  );

  if (contentWrapper && imageWrapper) {
    const contentHeight = contentWrapper.offsetHeight;
    const imageHeight = imageWrapper.offsetHeight;

    if (contentHeight > imageHeight) {
      imageWrapper.style.height = contentHeight + "px";
    }
  }
}

function pushCustomerTag(email, updateLocalStorage = true) {
  if (updateLocalStorage) {
    localStorage.setItem("klaviyoEmail", email);
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "email_submission",
    "Event Parameters": [
      {
        name: "Email",
        value: email,
      },
      {
        name: "Store",
        value: window.location.origin,
      },
    ],
    Email: email,
    Store: window.location.origin,
  });

  console.log("pushed", window.dataLayer);
}

function saveNewEmails() {
  const inputEl = document.querySelector("#saveEmailInput");
  const honeypotField = document.querySelector("#honeypot");
  const inputWrapper = document.querySelector("#saveEmailWrapper");
  const errorMsg = document.querySelector("#error-msg");
  const buttonEl = document.querySelector("#saveEmail");
  const msg1 = document.querySelector(".msg1");
  const msg2 = document.querySelector(".msg2");
  // New Email input functionalities
  const bannerButton = document.querySelector(".hero__container .hero__cta");
  const emailpageButton = document.querySelector(
    ".header-main-header__quick-links-cta"
  );
  const emailpageButtonMobile = document.querySelector(
    ".header-main-header__quick-links-cta-mobile"
  );

  const getRecaptcheToken = async () => {
    let recaptcha_token = "";
    grecaptcha.ready(() => {
      grecaptcha
        .execute("6LcCR2cUAAAAANS1Gpq_mDIJ2pQuJphsSQaUEuc9", {
          action: "submit",
        })
        .then((token) => {
          recaptcha_token = token;
        });
    });
    while (recaptcha_token == "") {
      await new Promise((r) => setTimeout(r, 100));
    }
    return recaptcha_token;
  };

  // New functionalities for new email input
  const checkEmailState = async () => {
    // New logic for Kandy's CF
    window.location.href = "/pages/quiz-main";
    return;
    const homePageEmailInput = document.querySelector("#saveEmailInput");
    const customerEmail = document.querySelector(".barkyn-customer")?.value;

    if (customerEmail) {
      window.location.href = "/products/o-plano-alimentar-do-seu-cao";
      return;
    }

    if (homePageEmailInput) {
      const email = homePageEmailInput.value;
      if (email) {
        const regex = new RegExp("[a-z0-9]+@[a-z]+.[a-z]{2,3}");
        const validEmail = regex.test(email);

        if (validEmail) {
          inputWrapper?.classList.remove("error");
          if (errorMsg) errorMsg.innerHTML = "";
          localStorage.setItem("klaviyoEmail", email);

          await checkClerkUser(email);
        } else {
          inputWrapper?.classList.add("error");
          if (errorMsg) errorMsg.innerHTML = "Email non valido";
        }
      } else {
        window.location.href = "/pages/email";
      }
    } else {
      if (bannerButton && bannerButton.href) {
        window.location.href = bannerButton.href;
        return;
      }

      window.location.href = "/pages/email";
    }
  };

  if (emailpageButton) {
    emailpageButton.addEventListener("click", async () => {
      await checkEmailState();
    });
  }

  if (bannerButton) {
    bannerButton.addEventListener("click", async () => {
      await checkEmailState();
    });
  }

  if (emailpageButtonMobile) {
    emailpageButtonMobile.addEventListener("click", async () => {
      await checkEmailState();
    });
  }
  // New functionalities for new email input end

  const registerKlaviyo = async (email, subscribeCustomer = false) => {
    const saveEmailButton = document.querySelector("#saveEmail");
    const buttonRedirectUrl = saveEmailButton?.dataset?.redirectUrl;

    let redirectUrl = "/products/o-plano-alimentar-do-seu-cao";
    let isLongevity = false;

    if (window.location.href.includes("longevity-email-step")) {
      redirectUrl = "/products/longevity-plan-free-food-trial";
      isLongevity = true;
    }

    if (buttonRedirectUrl) {
      redirectUrl = buttonRedirectUrl;
    }

    if (!email) return;
    try {
      await $.post(
        `${authApiUrl}/klaviyo-register`,
        JSON.stringify({ email, isLongevity })
      );

      inputWrapper?.classList.remove("error");
      if (errorMsg) errorMsg.innerHTML = "";
      if (msg1) msg1.style.display = "block";
      if (msg2) msg2.style.display = "none";

      pushCustomerTag(email);

      // Therse rows should be commented for the new functionalities for Onepage checkout
      // window.location.href = redirectUrl;
      // End of the rows that should be commented
    } catch (error) {
      console.log("error", error);
      return null;
    }
  };

  // New functionalities for Onepage checkout
  const clerkLogin = async (email, password) => {
    const clerkAuth = new ClerkAuth();

    const saveEmailButton = document.querySelector("#saveEmail");
    const buttonRedirectUrl = saveEmailButton?.dataset?.redirectUrl;

    let redirectUrl = "/products/o-plano-alimentar-do-seu-cao";

    if (window.location.href.includes("longevity-email-step")) {
      redirectUrl = "/products/longevity-plan-free-food-trial";
    }

    if (buttonRedirectUrl) {
      redirectUrl = buttonRedirectUrl;
    }

    try {
      const firstAttemptResponse = await clerkAuth.firstAttempt(email);

      if (!firstAttemptResponse?.response?.id) return;

      const { ok } = await clerkAuth.clerkSignin(email, password);
      if (ok) {
        await clerkAuth.autoLogin(redirectUrl);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const registerClerk = async (email) => {
    try {
      const response = await $.post(
        `${authApiUrl}/register-random-password`,
        JSON.stringify({ email })
      );

      if (response?.data?.password && response?.data?.user?.id) {
        await clerkLogin(email, response?.data?.password);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  // End of new functionalities for Onepage checkout

  const checkClerkUser = async (email) => {
    const button = document.querySelector("#saveEmail");
    if (button) button.classList.add("button--loading");

    try {
      const response = await $.post(
        `${authApiUrl}/check-clerk-user`,
        JSON.stringify({ email })
      );
      console.log("response", response);

      if (response.data.length > 0) {
        inputWrapper?.classList.add("error");
        if (errorMsg)
          errorMsg.innerHTML = "Já existe uma conta associada a esse email.";
        if (msg1) msg1.style.display = "none";
        if (msg2) msg2.style.display = "block";
      } else {
        await registerKlaviyo(email, true);
        await registerClerk(email);
      }
      if (button) button.classList.remove("button--loading");
    } catch (error) {
      console.log("error", error);
      if (button) button.classList.remove("button--loading");
      return null;
    }
  };

  if (buttonEl) {
    buttonEl.addEventListener("click", async () => {
      const token = await getRecaptcheToken();

      if (!token) {
        return;
      }

      let honeypot = "";
      if (honeypotField) honeypot = honeypotField.value;

      if (honeypot !== "") {
        return;
      }

      const customerEmail = inputEl?.value;
      const regex = new RegExp("[a-z0-9]+@[a-z]+.[a-z]{2,3}");
      let hasEmail = false;
      let isEmail = false;

      if (!customerEmail) {
        hasEmail = false;
        inputWrapper?.classList.add("error");
        if (errorMsg)
          errorMsg.innerHTML = "Preencha todos os campos obrigatórios";
      } else {
        hasEmail = true;
        isEmail = regex.test(customerEmail);

        if (isEmail) {
          inputWrapper?.classList.remove("error");
          if (errorMsg) errorMsg.innerHTML = "";
        } else {
          inputWrapper?.classList.add("error");
          if (errorMsg)
            errorMsg.innerHTML =
              "Este e-mail não é válido. Por favor, verifique e tente de novo.";
        }
      }

      if (hasEmail && isEmail) {
        await checkClerkUser(customerEmail);
      }
    });
  }

  if (inputEl) {
    inputEl.addEventListener("keydown", async (e) => {
      if (e.key === "Enter") {
        const token = await getRecaptcheToken();

        if (!token) {
          return;
        }

        let honeypot = "";
        if (honeypotField) honeypot = honeypotField.value;

        if (honeypot !== "") {
          return;
        }

        const customerEmail = inputEl?.value;
        const regex = new RegExp("[a-z0-9]+@[a-z]+.[a-z]{2,3}");
        let hasEmail = false;
        let isEmail = false;

        if (!customerEmail) {
          hasEmail = false;
          inputWrapper?.classList.add("error");
          if (errorMsg)
            errorMsg.innerHTML = "Preencha todos os campos obrigatórios";
        } else {
          hasEmail = true;
          isEmail = regex.test(customerEmail);

          if (isEmail) {
            inputWrapper?.classList.remove("error");
            if (errorMsg) errorMsg.innerHTML = "";
          } else {
            inputWrapper?.classList.add("error");
            if (errorMsg)
              errorMsg.innerHTML =
                "Este e-mail não é válido. Por favor, verifique e tente de novo.";
          }
        }

        if (hasEmail && isEmail) {
          // await registerKlaviyo(customerEmail);
          await checkClerkUser(customerEmail);
        }
      }
    });
  }

  if (inputEl) {
    inputEl.addEventListener("keydown", async (e) => {
      if (e.key === "Enter") {
        const token = await getRecaptcheToken();

        if (!token) {
          return;
        }

        const customerEmail = inputEl?.value;
        const regex = new RegExp("[a-z0-9]+@[a-z]+.[a-z]{2,3}");
        let hasEmail = false;
        let isEmail = false;

        if (!customerEmail) {
          hasEmail = false;
          inputWrapper?.classList.add("error");
          if (errorMsg)
            errorMsg.innerHTML = "Preencha todos os campos obrigatórios";
        } else {
          hasEmail = true;
          isEmail = regex.test(customerEmail);

          if (isEmail) {
            inputWrapper?.classList.remove("error");
            if (errorMsg) errorMsg.innerHTML = "";
          } else {
            inputWrapper?.classList.add("error");
            if (errorMsg)
              errorMsg.innerHTML =
                "Este e-mail não é válido. Por favor, verifique e tente de novo.";
          }
        }

        if (hasEmail && isEmail) {
          await registerKlaviyo(customerEmail);
        }
      }
    });
  }
}

// window onload function
$(window).on("load", function () {
  calculateImageHeight();
  saveNewEmails();

  const hideCallpage = () => {
    const interval = setInterval(function () {
      const callModal = document.querySelector(".cp-widget-button__inner");

      if (callModal) {
        const callWrapper = document.querySelector("#callpageWrapper");

        if (callWrapper) {
          callWrapper.classList.add("hidden");
        }

        clearInterval(interval);
      }
    }, 250);
  };

  hideCallpage();

  const checkCallButton = () => {
    const interval = setInterval(function () {
      const callButton = document.querySelector(".Custom_Link_1-channel a");

      if (callButton) {
        const loadButton = document.querySelector(".barkyn-callpage-script");

        if (loadButton) {
          callButton.parentNode.classList.add("visible");

          callButton.addEventListener("click", function (e) {
            e.preventDefault();

            const callWrapper = document.querySelector("div#callpageWrapper");
            if (callWrapper) callWrapper.classList.remove("hidden");

            const callModal = document.querySelector(
              ".cp-widget-button__inner"
            );
            callModal.click();
          });
        }
        clearInterval(interval);
      }
    }, 500);
  };

  checkCallButton();

  const quizButton = document.querySelector(
    ".product-form__submit.button.button--primary"
  );
  const apiUrl = document.querySelector(".barkyn-api-url").value;

  const saveKlaviyoCustomer = async (klaviyoUser, dogsData, lifeStage) => {
    if (!klaviyoUser || !dogsData?.length || !lifeStage) return;

    const newLifeStage = lifeStage.split(" ")[0];

    const formData = {
      email: klaviyoUser,
      dogsData,
      lifeStage: newLifeStage,
    };

    try {
      const response = await $.post(
        `${apiUrl}/sync-klaviyo-customer-v2`,
        JSON.stringify(formData)
      );
    } catch (error) {
      console.log(error);
    }
  };

  if (quizButton) {
    quizButton.addEventListener("click", async () => {
      const klaviyoUser = localStorage.getItem("klaviyoEmail");

      if (klaviyoUser) {
        const newDogsRows = document.querySelectorAll(
          ".acq-flow__main-form-row"
        );
        const dogsData = [];

        newDogsRows.forEach((row) => {
          const dogGender = row.querySelector(
            ".acq-fake-dropdown__selected-option"
          )?.innerText;
          let genderPrefix = "a";
          if (dogGender === "Macho") genderPrefix = "o";
          const dogName = row.querySelector(".dog-name-input")?.value;

          if (dogGender && dogName && dogGender !== "Escolha um")
            dogsData.push({ gender: genderPrefix, name: dogName.trim() });
        });

        let lifeStage = null;
        const productOptions = document.querySelectorAll(
          ".product-dropdown-option"
        );

        if (productOptions.length > 0) {
          productOptions.forEach((option, index) => {
            const optionElement = option.querySelector(
              ".fake-dropdown__selected-option"
            );

            if (index === 0) lifeStage = optionElement?.innerText;
          });
        }

        await saveKlaviyoCustomer(klaviyoUser, dogsData, lifeStage);
      }

      const ritualButton = document.querySelector(".cart-ritual-product");

      if (ritualButton) {
        setTimeout(() => {
          document
            .querySelector(".cart-ritual-product")
            .classList.add("active");
        }, 2000);
      }
    });
  }

  toggleSidecart();

  setTimeout(function () {
    showToaster();
    // configureToaster('Toaster title', 'Toaster message', 'success');
  }, 1000);

  // Custome new tag
  const pageUrl = window.location.href;

  // console.log("customer id:", getCustomerId());
  // if (
  //   (window.location.pathname.includes('/pages/email') || window.location.pathname.includes('/pages/quiz')) && getCustomerId()
  // ) {
  //   switch (Shopify.country) {
  //     case "PT":
  //       window.location.href = "/products/o-plano-alimentar-do-seu-cao"
  //       break
  //     case "ES":
  //       window.location.href = "/products/plan-nutricional-personalizado"
  //       break
  //     case "IT":
  //       window.location.href = "/products/piano-nutrizionale-personalizzato"
  //       break
  //   }
  //   window.location.href = "/products/o-plano-alimentar-do-seu-cao"
  // }

  // if (pageUrl.includes("pages/email")) {
  //   const mainWrapper = document.querySelector("main.main-content");

  //   mainWrapper.addEventListener("click", (e) => {
  //     if (
  //       e.target.classList.contains("kl-private-reset-css-Xuajs1") &&
  //       e.target.type === "button"
  //     ) {
  //       const parentWrapper = e.target.parentElement?.parentElement;

  //       const email = parentWrapper.querySelector('input[name="email"]')?.value;

  //       if (!email) return;

  //       pushCustomerTag(email);
  //     }
  //   });

  //   const klaviyoForm = document.querySelector("form.klaviyo-form");
  //   const klaviyoButton = klaviyoForm.querySelector("button");
  //   const klaviyoFooter = document.querySelector(".footer__newsletter");
  //   if (klaviyoButton) {
  //     klaviyoFooter.addEventListener("click", (e) => {
  //       if (
  //         e.target.classList.contains("kl-private-reset-css-Xuajs1") &&
  //         e.target.type === "button"
  //       ) {
  //         const email = klaviyoFooter.querySelector(
  //           'input[name="email"]'
  //         )?.value;

  //         if (!email) return;

  //         pushCustomerTag(email);
  //       }
  //     });
  //   }
  // }
  //  End of custome new tag

  /**
   * Check URL for params dogName and dogGender
   */
  const ritualProductPageUrlPT = "/products/o-plano-alimentar-do-seu-cao";
  const longevityProductPageUrlPT = "/products/longevity-plan-free-food-trial";

  if (
    window.location.pathname.includes(ritualProductPageUrlPT) ||
    window.location.pathname.includes(longevityProductPageUrlPT)
  ) {
    const parsedUrl = new URL(window.location.href);
    const urlSearchParams = new URLSearchParams(parsedUrl.search);

    const form = $("product-form.product-form");

    let filterName, filterValue;

    for (const filter of urlSearchParams) {
      filterName = filter[0];
      filterValue = filter[1];
      let dogNames;
      let dogGenders;

      // Check if URL is filtering by dog name
      if (filterName == "dogName") {
        // Get all input fields where dog name should be filled
        const dogNameInput = form.find(".acq-flow__main-form .dog-name-input");

        // Get dog name or names
        dogNames = getDogFilterValues(filterValue);

        // Loop through dog names on URL and add accordingly to the exisiting inputs
        // If there are more in the URL than input fields then the first dog name
        // will be used to fill
        dogNames.forEach(function (name, index) {
          $(dogNameInput[index]).val(name);
        });
      }

      // Check if URL is filtering by dog name
      if (filterName == "dogGender") {
        // Get all input fields where dog gender should be filled
        const dogGenderInput = form.find(
          ".acq-flow__main-form .acq-fake-dropdown .fake-dropdown__input"
        );
        let selectedOptionElement = form.find(
          ".acq-flow__main-form .acq-fake-dropdown__selected-option"
        );

        // Get available gender options
        const genderOptions = form
          .find(".acq-fake-dropdown__option")
          .map(function () {
            return {
              text: $.trim($(this).text()),
              element: $(this),
            };
          })
          .get();

        // Get dog gender or genders
        dogGenders = getDogFilterValues(filterValue);

        // Loop through gender/s in URL to fill inputs accordingly
        dogGenders.forEach(function (gender, index) {
          let queryValue = normalizeString(gender);

          let found = false;
          genderOptions.forEach(function (option) {
            let optionText = normalizeString(option.text);
            if (optionText === queryValue) {
              $(dogGenderInput[index]).val(option.text);
              $(selectedOptionElement[index]).text(option.text);
              found = true;
              return false;
            }
          });

          if (!found) {
            console.log("Opção não encontrada");
          }
        });
      }
    }
  }

  function normalizeString(str) {
    return str
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase();
  }

  function getDogFilterValues(filterArray) {
    const values = filterArray.replace(/ /g, "").split(",");
    return values;
  }

  addEventListener("scroll", () => {
    if (window.scrollY > 1) {
      if (document.querySelector(".scroll"))
        document.querySelector(".scroll").style.display = "none";
    } else {
      if (document.querySelector(".scroll"))
        document.querySelector(".scroll").style.display = "block";
    }
  });

  addEventListener("klaviyoForms", (e) => {
    if (e.detail.type == "submit") {
      switch (e.detail.formId) {
        // PT | Lead magnet - Supplement recipes
        case "XYz48P": {
          const leadEmail = e.detail.metaData["$email"];
          pushCustomerTag(leadEmail, false);
        }
      }
    }
  });
});

var getCustomerId = function () {
  try {
    let curr = window.ShopifyAnalytics.meta.page.customerId;
    if (curr !== undefined && curr !== null && curr !== "") {
      return curr;
    }
  } catch (e) {}
  try {
    let curr = window.meta.page.customerId;
    if (curr !== undefined && curr !== null && curr !== "") {
      return curr;
    }
  } catch (e) {}
  return null;
};

const referFriendButton = $(
  ".credityard-panel.credityard-refer-a-friend .credityard-refer-a-friend-info .credityard-panel-info-shop-icon"
);
referFriendButton.click(function (e) {
  $("#loyaltylion").hide();

  const href = $(this).attr("href");

  window.location.href = href;
});

function isDiscountAdded() {
  let codeCookieValue;

  const getCookie = function (name) {
    let value = "; " + document.cookie;
    let parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
  };

  codeCookieValue = getCookie("discount_code");

  if (codeCookieValue == "LAST30") {
    return true;
  } else {
    return false;
  }
}

function getDogsPropertyFromProperties(properties) {
  const dogKeyRegex = /^_?dogs$/;

  if (typeof properties !== "object" || properties === null) {
    console.error("Invalid properties input. Expected an object.");
    return null;
  }

  const dogsEntry = Object.entries(properties).find(([key, _]) => {
    return dogKeyRegex.test(key);
  });

  return dogsEntry ? dogsEntry[1] : [];
}

(function () {
  // ─── Cart/Add XHR Interceptor ───
  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this._requestUrl = url;
    return originalXHROpen.call(this, method, url, ...rest);
  };

  XMLHttpRequest.prototype.send = function (requestBody) {
    // Only intercept the “add to cart” endpoint
    if (this._requestUrl?.includes("/cart/add")) {
      const purchaseOption = document.querySelector(
        '[name="purchase_option"]'
      )?.value;
      const planId = document.querySelector('[name="selling_plan_id"]')?.value;
      console.log(
        "[CartAdd] purchase_option =",
        purchaseOption,
        "selling_plan_id =",
        planId
      );

      if (purchaseOption === "subscription" && planId) {
        // 1) JSON-style request payload?
        if (
          typeof requestBody === "string" &&
          requestBody.trim().startsWith("{")
        ) {
          try {
            const payload = JSON.parse(requestBody);

            // Inject the selling_plan into the **new item(s)** being added
            if (Array.isArray(payload.items)) {
              payload.items = payload.items.map((item) => ({
                ...item,
                selling_plan: planId,
              }));
            } else {
              // Legacy format: single-item payload
              payload.selling_plan = planId;
            }

            requestBody = JSON.stringify(payload);
            console.log("[CartAdd] injected plan into JSON payload:", payload);
          } catch (e) {
            console.warn(
              "[CartAdd] JSON parse error, skipping JSON injection",
              e
            );
          }
        }
        // 2) Form-encoded fallback
        else {
          try {
            const params = new URLSearchParams(requestBody);
            params.set("selling_plan", planId);
            requestBody = params.toString();
            console.log(
              "[CartAdd] injected plan into form payload:",
              Object.fromEntries(params)
            );
          } catch (e) {
            console.warn(
              "[CartAdd] Form parse error, skipping form injection",
              e
            );
          }
        }
      }
    }

    return originalXHRSend.call(this, requestBody);
  };
})();
